<template>
    <div>
        <div class="header pb-4">
            <span class="title ">Merkliste auswählen</span>
        </div>
        <div class="content mb-4 ">
            <span class="NameSpan">Bitte wählen Sie eine Merkliste aus</span>
            <select style="width: 100%;" v-model="SelectedWishList" required >
                <option v-for="item in WishList" :value="item.wishlistid">
                    {{ item.wishlistname }}
                </option>
            </select>

        </div>
        <div class="wishlistCheckbox" hidden>
            <input type="checkbox" />
            <span style="font-size: 12px !important;top: -3px;">Alle weiteren Artikel direkt zu dieser Merkliste hinzufügen</span>
            <span v-if="AddError" style="color:red">*</span>
        </div>
        <div class="wishlist-footer">
            <div>
                <input type="button" class="first-btn" value="Speichern" @click="AddToWishList()" />
            </div>
            <div>
                <input type="button" class="second-btn" value="Schließen" @click="modalClose()" />
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import notify from 'devextreme/ui/notify';
    import ResourceHelper from "@common/globalization/ResourceHelper";
    export default {
        components: {
        
            notify,
        },
       props: ['wishListEan'],
        data() {
            return {
                WishList: [],
                SelectedWishList: "",
                loading: true,
                AddError: false,
                translationKeywords: {
                    addedSuccessfully: "",
                    notFoundOrExists:""
                },
            };
        },
        methods: {
            translation: function () {
                this.translationKeywords.addedSuccessfully =
                    ResourceHelper.getString("addedSuccessfully");
                this.translationKeywords.notFoundOrExists =
                    ResourceHelper.getString("notFoundOrExists");
            },
            loadWishList: function () {
                var refTothis = this;
                var PortalId = getCookie("PortalId");
                var UserGuid = getCookie("UserId");
                var Lang = getCookie("Esperantus_Language_languageSwitcher");
                var SearchUrl = getSearchUrl();
                let authorizationToken = getCookie("ApiToken");
                axios({
                    method: 'Get',
                    url: SearchUrl + '/WishList/UserWishList?&userId=' + UserGuid + "&portalId=" + PortalId + '&culture=' + Lang,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                        "authorization": "Bearer " + authorizationToken,
                    }
                }).then(function (result) {
                    if (result) {
                     
                        refTothis.WishList = result.data.wishLists;
                        refTothis.loading = false; 
                    }
                });
            },
        

            AddToWishList: function () {
                this.AddError = false
                var refTothis = this;
                if (refTothis.SelectedWishList) {
                    var PortalId = getCookie("PortalId");
                    var SearchUrl = getSearchUrl();
                    let authorizationToken = getCookie("ApiToken");
                    axios({
                        method: 'Get',
                        url: SearchUrl + '/WishList/AddToWishList?&portalId=' + PortalId + "&wishListGuid=" + refTothis.SelectedWishList + '&itemEan=' + refTothis.wishListEan,
                        headers: {
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                            "authorization": "Bearer " + authorizationToken,
                        }
                    }).then(function (result) {
                        console.log(result.data.result)
                        if (result.status === 200) {
                            var value = result.data.result;

                            if (value === true) {

                                refTothis.modalClose();
                                notify({
                                    message: refTothis.translationKeywords.addedSuccessfully,
                                    width: 400,
                                    position: {
                                        my: 'center bottom',
                                        at: 'center bottom',
                                    },
                                }, 'success', 3000);
                            }
                        }
                        if (result.data.result === false) {
                            notify({
                                message: refTothis.translationKeywords.notFoundOrExists,
                                width: 400,
                                position: {
                                    my: 'center bottom',
                                    at: 'center bottom',
                                },
                            }, 'error', 3000);
                        }
                  
                    });

                }
                else {
                    this.AddError = true;
                }
            },
            modalClose: function () {
                this.$root.$emit('bv::hide::modal', "wishList-modal");
            },
    
        },
     
        created: function () {
            this.loadWishList();
            this.translation();
        },
              

    }
</script>